/* Garazha — boshti i përshtatjes.
   Një makinë e ruajtur, e lexuar nga çdo kartë, çdo PDP, çdo koleksion.
   Ruajtja është vetëm lehtësi: asgjë në faqe nuk prishet nëse është bosh
   ose nëse shfletuesi nuk lejon ruajtje.

   Makina zgjidhet nga tri lista të vërteta (Marka -> Modeli -> Gjenerata),
   të mbushura nga assets/fitment.js, e cila ndërtohet nga titujt realë të katalogut.
   Asgjë nuk shkruhet me dorë, prandaj asgjë nuk mbetet pa u krahasuar dot. */
(function (w, d) {
  'use strict';
  var KEY = 'bajrami.car.v1';
  var DATA = w.BAJRAMI_FIT || {};

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); }
    catch (e) { return null; }
  }
  function write(car) { try { localStorage.setItem(KEY, JSON.stringify(car)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  /* Etiketa e gjeneratës lexohet gjithmonë nga katalogu i tanishëm, jo nga ajo
     që u ruajt dikur — përndryshe një makinë e ruajtur javën e kaluar do të
     mbante vite që i kemi ndrequr që atëherë. */
  /* Makinat e ruajtura para se ta shtonim rangun e viteve nuk i kanë ato fusha.
     I plotësojmë nga katalogu, që përshtatja të mos mbetet peng e një ruajtjeje të vjetër. */
  function hydrate(car) {
    if (!car || !car.model || car.from) return car;
    var list = (DATA[car.make] || {})[car.model] || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].g === car.gen) { car.from = list[i].f || 0; car.to = list[i].t || 0; break; }
    }
    return car;
  }
  function genLabel(car) {
    if (!car || !car.gen) return car && car.genLabel || '';
    var list = (DATA[car.make] || {})[car.model] || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].g === car.gen) return list[i].l;
    }
    return car.genLabel || car.gen;
  }
  function label(car) {
    if (!car) return '';
    return [car.make, car.model, genLabel(car)].filter(Boolean).join(' ');
  }
  /* Fjalët me të cilat e kërkojmë këtë makinë në dyqan. */
  function query(car) {
    if (!car || !car.model) return '';
    if (car.gen && car.gen.indexOf(car.model) > -1) return car.gen;
    return [car.model, car.gen].filter(Boolean).join(' ');
  }
  function shortLabel(car) {
    if (!car) return '';
    return [car.model, car.gen].filter(Boolean).join(' ');
  }

  /* "Marka|Modeli|Gjenerata|Lloji" -> objekt. Fushë bosh = nuk e dimë. */
  function parseFit(s) {
    var p = String(s || '').split('|');
    var y = String(p[4] || '').split('-');
    return { make: p[0] || '', model: p[1] || '', gen: p[2] || '', part: p[3] || '',
             from: parseInt(y[0], 10) || 0, to: parseInt(y[1], 10) || 0 };
  }

  /* Krahason makinën e ruajtur me identitetin e pjesës.
     Kthen 'fit' | 'nofit' | 'unknown'. "Nuk e di" është përgjigje e plotë —
     një "po" të rremë nuk e japim kurrë. */
  function match(car, fit) {
    if (!car || !fit) return 'unknown';
    if (typeof fit === 'string') fit = parseFit(fit);
    if (!fit.make || !fit.model) return 'unknown';
    if (norm(car.make) !== norm(fit.make)) return 'nofit';
    if (norm(car.model) !== norm(fit.model)) return 'nofit';
    /* Modelet ku titulli nuk e shkruan kodin (Q7, Tiguan, Cayenne…) i krahasojmë
       me vitet: nëse rangu i pjesës dhe rangu i gjeneratës preken, i përshtatet. */
    if (!fit.gen && fit.from && car.from) {
      var pt = fit.to || 9999, ct = car.to || 9999;
      /* Kufijtë ekskluzivë: te viti ku mbaron një gjeneratë fillon tjetra. */
      return (fit.from < ct && car.from < pt) ? 'fit' : 'nofit';
    }
    if (!fit.gen || !car.gen) return 'unknown';
    if (norm(car.gen) === norm(fit.gen)) return 'fit';
    /* Facelifti e ndan gjeneratën më dysh, dhe pjesët nuk ndërrohen mes tyre.
       Por kur titulli nuk e thotë as njërën as tjetrën, ne nuk e dimë — dhe
       një "jo" i gabuar kushton po aq sa një "po" i gabuar. Prandaj: nuk e di. */
    var a = norm(car.gen).replace(' facelift', '');
    var b = norm(fit.gen).replace(' facelift', '');
    if (a === b) return 'unknown';
    return 'nofit';
  }

  var Garage = {
    key: KEY, get: function () { return hydrate(read()); }, label: label, shortLabel: shortLabel,
    genLabel: genLabel, query: query, refresh: function(){ paint(); },
    match: match, parseFit: parseFit, data: DATA,
    set: function (car) { write(car); this.emit(); },
    clear: function () { clear(); this.emit(); },
    emit: function () { d.dispatchEvent(new CustomEvent('garage:change', { detail: read() })); }
  };
  w.Garage = Garage;

  /* --- shenja në header --- */
  function paintChip() {
    var car = hydrate(read()), els = d.querySelectorAll('[data-mycar]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], v = el.querySelector('.mycar__v');
      el.setAttribute('data-empty', car ? 'false' : 'true');
      if (v) v.textContent = car ? label(car) : (el.getAttribute('data-empty-label') || 'Zgjedh makinën');
    }
  }

  /* --- çdo shenjë përshtatjeje në faqe --- */
  function paintBadges() {
    var car = hydrate(read()), nodes = d.querySelectorAll('[data-fit]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i], fit = parseFit(el.getAttribute('data-fit'));
      var state = match(car, fit);
      el.setAttribute('data-state', state);
      var txt = el.getAttribute('data-label-' + state);
      if (txt) {
        var slot = el.querySelector('[data-fit-text]') || el;
        slot.textContent = txt.replace('{car}', label(car))
                              .replace('{fit}', [fit.make, fit.model, fit.gen].filter(Boolean).join(' '));
      }
      el.classList.remove('chip--ok', 'chip--warn', 'chip--red');
      el.classList.add(state === 'fit' ? 'chip--ok' : state === 'nofit' ? 'chip--red' : 'chip--warn');
    }
  }

  function paint() { paintChip(); paintBadges(); }

  /* --- listat e varura: Marka -> Modeli -> Gjenerata --- */
  function opt(sel, list, placeholder, value) {
    sel.innerHTML = '';
    var o = d.createElement('option');
    o.value = ''; o.textContent = placeholder;
    sel.appendChild(o);
    for (var i = 0; i < list.length; i++) {
      var x = d.createElement('option');
      x.value = list[i].v; x.textContent = list[i].l;
      if (list[i].d) x.setAttribute('data-label', list[i].d);
      if (list[i].f) x.setAttribute('data-f', list[i].f);
      if (list[i].t) x.setAttribute('data-t', list[i].t);
      sel.appendChild(x);
    }
    sel.disabled = list.length === 0;
    if (value) sel.value = value;
  }

  function fillPicker(form, car) {
    var mk = form.querySelector('[data-car-make]'),
        md = form.querySelector('[data-car-model]'),
        gn = form.querySelector('[data-car-gen]');
    if (!mk || !md || !gn) return;

    var makes = Object.keys(DATA).sort();
    opt(mk, makes.map(function (m) { return { v: m, l: m }; }),
        mk.getAttribute('aria-label') || 'Marka', car && car.make);

    function models() {
      var b = DATA[mk.value] || {};
      var list = Object.keys(b).sort().map(function (m) { return { v: m, l: m }; });
      opt(md, list, md.getAttribute('aria-label') || 'Modeli', car && car.model);
      gens();
    }
    function gens() {
      var g = ((DATA[mk.value] || {})[md.value]) || [];
      opt(gn, g.map(function (x) { return { v: x.g || x.l, l: x.l, d: x.l, f: x.f, t: x.t }; }),
          gn.getAttribute('aria-label') || 'Gjenerata', car && car.gen);
    }
    mk.addEventListener('change', function () { models(); });
    md.addEventListener('change', function () { gens(); });
    if (mk.value) models();
  }

  function pickers() {
    var car = hydrate(read()), fs = d.querySelectorAll('[data-garage-form]');
    for (var i = 0; i < fs.length; i++) fillPicker(fs[i], car);
  }

  d.addEventListener('garage:change', paint);
  function boot() { pickers(); paint(); }
  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  /* --- ruajtja --- */
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-garage-form]');
    if (!f) return;
    e.preventDefault();
    var g = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
    var gsel = f.querySelector('[data-car-gen]');
    var gopt = gsel && gsel.selectedIndex > -1 ? gsel.options[gsel.selectedIndex] : null;
    var car = { make: g('make'), model: g('model'), gen: g('gen'),
                genLabel: gopt ? (gopt.getAttribute('data-label') || gopt.textContent) : '',
                from: gopt ? parseInt(gopt.getAttribute('data-f'), 10) || 0 : 0,
                to:   gopt ? parseInt(gopt.getAttribute('data-t'), 10) || 0 : 0 };
    if (!car.make || !car.model) return;
    Garage.set(car);
    var to = f.getAttribute('data-redirect');
    if (to) w.location.href = to;
  });

  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-garage-clear]')) {
      e.preventDefault();
      Garage.clear();
      var fs = d.querySelectorAll('[data-garage-form]');
      for (var i = 0; i < fs.length; i++) fs[i].reset();
      pickers();
    }
  });
})(window, document);
